export default __webpack_public_path__ + "static/Image-Access-To-Behavioral-Health-Care-4e0281c4454212aa1a42468a25353b9d.jpg";